export const localidades = [
    {
        value: "010000",
        label: "DISTRITO NACIONAL",
        municipios: [
            {
                value: "010100",
                label: "MUNICIPIO SANTO DOMINGO DE GUZMÁN",
            },
            {
                value: "010101",
                label: "SANTO DOMINGO DE GUZMÁN (D. M.).",
            },
        ]
    },
    {
        value: "020000",
        label: "AZUA",
        municipios: [
            {
                value: "020100",
                label: "MUNICIPIO AZUA",
            },
            {
                value: "020101",
                label: "AZUA (D. M.).",
            },
            {
                value: "020102",
                label: "BARRO ARRIBA (D. M.).",
            },
            {
                value: "020103",
                label: "LAS BARÍAS-LA ESTANCIA (D. M.).",
            },
            {
                value: "020104",
                label: "LOS JOVILLOS (D. M.).",
            },
            {
                value: "020105",
                label: "PUERTO VIEJO (D. M.).",
            },
            {
                value: "020106",
                label: "BARRERAS (D. M.).",
            },
            {
                value: "020107",
                label: "DOÑA EMMA BALAGUER VIUDA VALLEJO (D. M.).",
            },
            {
                value: "020108",
                label: "CLAVELLINA (D. M.).",
            },
            {
                value: "020109",
                label: "LAS LOMAS (D. M.).",
            },
            {
                value: "020200",
                label: "MUNICIPIO LAS CHARCAS",
            },
            {
                value: "020201",
                label: "LAS CHARCAS (D. M.).",
            },
            {
                value: "020202",
                label: "PALMAR DE OCOA (D. M.).",
            },
            {
                value: "020300",
                label: "MUNICIPIO LAS YAYAS DE VIAJAMA",
            },
            {
                value: "020301",
                label: "LAS YAYAS DE VIAJAMA (D. M.).",
            },
            {
                value: "020302",
                label: "VILLARPANDO (D. M.).",
            },
            {
                value: "020303",
                label: "HATO NUEVO CORTÉS (D. M.).",
            },
            {
                value: "020400",
                label: "MUNICIPIO PADRE LAS CASAS",
            },
            {
                value: "020401",
                label: "PADRE LAS CASAS (D. M.).",
            },
            {
                value: "020402",
                label: "LAS LAGUNAS (D. M.).",
            },
            {
                value: "020403",
                label: "LA SIEMBRA (D. M.).",
            },
            {
                value: "020404",
                label: "MONTE BONITO (D. M.).",
            },
            {
                value: "020405",
                label: "LOS FRÍOS (D. M.).",
            },
            {
                value: "020500",
                label: "MUNICIPIO PERALTA",
            },
            {
                value: "020501",
                label: "PERALTA (D. M.).",
            },
            {
                value: "020600",
                label: "MUNICIPIO SABANA YEGUA",
            },
            {
                value: "020601",
                label: "SABANA YEGUA (D. M.).",
            },
            {
                value: "020602",
                label: "PROYECTO 4 (D. M.).",
            },
            {
                value: "020603",
                label: "GANADERO (D. M.).",
            },
            {
                value: "020604",
                label: "PROYECTO 2-C (D. M.).",
            },
            {
                value: "020700",
                label: "MUNICIPIO PUEBLO VIEJO",
            },
            {
                value: "020701",
                label: "PUEBLO VIEJO (D. M.).",
            },
            {
                value: "020702",
                label: "EL ROSARIO (D. M.).",
            },
            {
                value: "020800",
                label: "MUNICIPIO TÁBARA ARRIBA",
            },
            {
                value: "020801",
                label: "TÁBARA ARRIBA (D. M.).",
            },
            {
                value: "020802",
                label: "TÁBARA ABAJO (D. M.).",
            },
            {
                value: "020803",
                label: "AMIAMA GÓMEZ (D. M.).",
            },
            {
                value: "020804",
                label: "LOS TOROS (D. M.).",
            },
            {
                value: "020900",
                label: "MUNICIPIO GUAYABAL",
            },
            {
                value: "020901",
                label: "GUAYABAL (D. M.).",
            },
            {
                value: "021000",
                label: "MUNICIPIO ESTEBANÍA",
            },
            {
                value: "021001",
                label: "ESTEBANÍA (D. M.).",
            },
        ]
    },
    {
        value: "030000",
        label: "BAHORUCO",
        municipios: [
            {
                value: "030001",
                label: "MUNICIPIO NEIBA",
            },
            {
                value: "030101",
                label: "NEIBA (D. M.).",
            },
            {
                value: "030102",
                label: "EL PALMAR (D. M.).",
            },
            {
                value: "030200",
                label: "MUNICIPIO GALVÁN",
            },
            {
                value: "030201",
                label: "GALVÁN (D. M.).",
            },
            {
                value: "030202",
                label: "EL SALADO (D. M.).",
            },
            {
                value: "030300",
                label: "MUNICIPIO TAMAYO",
            },
            {
                value: "030301",
                label: "TAMAYO (D. M.).",
            },
            {
                value: "030302",
                label: "UVILLA (D. M.).",
            },
            {
                value: "030303",
                label: "SANTANA (D. M.).",
            },
            {
                value: "030304",
                label: "MONSERRATE (MONTSERRAT) (D. M.).",
            },
            {
                value: "030305",
                label: "CABEZA DE TORO (D. M.).",
            },
            {
                value: "030306",
                label: "MENA (D. M.).",
            },
            {
                value: "030307",
                label: "SANTA BÁRBARA EL 6 (D. M.).",
            },
            {
                value: "030400",
                label: "MUNICIPIO VILLA JARAGUA",
            },
            {
                value: "030401",
                label: "VILLA JARAGUA (D. M.).",
            },
            {
                value: "030500",
                label: "MUNICIPIO LOS RÍOS",
            },
            {
                value: "030501",
                label: "LOS RÍOS (D. M.).",
            },
            {
                value: "030502",
                label: "LAS CLAVELLINAS (D. M.).",
            },
        ]
    },
    {
        value: "040000",
        label: "BARAHONA",
        municipios: [
            {
                value: "040100",
                label: "MUNICIPIO BARAHONA",
            },
            {
                value: "040101",
                label: "BARAHONA (D. M.).",
            },
            {
                value: "040102",
                label: "EL CACHÓN (D. M.).",
            },
            {
                value: "040103",
                label: "LA GUÁZARA (D. M.).",
            },
            {
                value: "040104",
                label: "VILLA CENTRAL (D. M.).",
            },
            {
                value: "040200",
                label: "MUNICIPIO CABRAL",
            },
            {
                value: "040201",
                label: "CABRAL (D. M.).",
            },
            {
                value: "040300",
                label: "MUNICIPIO ENRIQUILLO",
            },
            {
                value: "040301",
                label: "ENRIQUILLO (D. M.).",
            },
            {
                value: "040302",
                label: "ARROYO DULCE (D. M.).",
            },
            {
                value: "040400",
                label: "MUNICIPIO PARAÍSO",
            },
            {
                value: "040401",
                label: "PARAÍSO (D. M.).",
            },
            {
                value: "040402",
                label: "LOS PATOS (D. M.).",
            },
            {
                value: "040500",
                label: "MUNICIPIO VICENTE NOBLE",
            },
            {
                value: "040501",
                label: "VICENTE NOBLE (D. M.).",
            },
            {
                value: "040502",
                label: "CANOA (D. M.).",
            },
            {
                value: "040503",
                label: "QUITA CORAZA (D. M.).",
            },
            {
                value: "040504",
                label: "FONDO NEGRO (D. M.).",
            },
            {
                value: "040600",
                label: "MUNICIPIO EL PEÑÓN",
            },
            {
                value: "040601",
                label: "EL PEÑÓN (D. M.).",
            },
            {
                value: "040700",
                label: "MUNICIPIO LA CIÉNAGA",
            },
            {
                value: "040701",
                label: "LA CIÉNAGA (D. M.).",
            },
            {
                value: "040702",
                label: "BAHORUCO (D. M.).",
            },
            {
                value: "040800",
                label: "MUNICIPIO FUNDACIÓN",
            },
            {
                value: "040801",
                label: "FUNDACIÓN (D. M.).",
            },
            {
                value: "040802",
                label: "PESCADERÍA (D. M.).",
            },
            {
                value: "040900",
                label: "MUNICIPIO LAS SALINAS",
            },
            {
                value: "040901",
                label: "LAS SALINAS (D. M.).",
            },
            {
                value: "041000",
                label: "MUNICIPIO POLO",
            },
            {
                value: "041001",
                label: "POLO (D. M.).",
            },
            {
                value: "041100",
                label: "MUNICIPIO JAQUIMEYES",
            },
            {
                value: "041101",
                label: "JAQUIMEYES (D. M.).",
            },
            {
                value: "041102",
                label: "PALO ALTO (D. M.).",
            },
        ]
    },
    {
        value: "050000",
        label: "DAJABÓN",
        municipios: [
            {
                value: "050100",
                label: "MUNICIPIO DAJABÓN",
            },
            {
                value: "050101",
                label: "DAJABÓN (D. M.).",
            },
            {
                value: "050102",
                label: "CAÑONGO (D. M.).",
            },
            {
                value: "050200",
                label: "MUNICIPIO LOMA DE CABRERA",
            },
            {
                value: "050201",
                label: "LOMA DE CABRERA (D. M.).",
            },
            {
                value: "050202",
                label: "CAPOTILLO (D. M.).",
            },
            {
                value: "050203",
                label: "SANTIAGO DE LA CRUZ (D. M.).",
            },
            {
                value: "050300",
                label: "MUNICIPIO PARTIDO",
            },
            {
                value: "050301",
                label: "PARTIDO (D. M.).",
            },
            {
                value: "050400",
                label: "MUNICIPIO RESTAURACIÓN",
            },
            {
                value: "050401",
                label: "RESTAURACIÓN (D. M.).",
            },
            {
                value: "050500",
                label: "MUNICIPIO EL PINO",
            },
            {
                value: "050501",
                label: "EL PINO (D. M.).",
            },
            {
                value: "050502",
                label: "MANUEL BUENO (D. M.).",
            },
        ]
    },
    {
        value: "060000",
        label: "DUARTE",
        municipios: [
            {
                value: "060100",
                label: "MUNICIPIO SAN FRANCISCO DE MACORÍS",
            },
            {
                value: "060101",
                label: "SAN FRANCISCO DE MACORÍS (D. M.).",
            },
            {
                value: "060102",
                label: "LA PEÑA (D. M.).",
            },
            {
                value: "060103",
                label: "CENOVÍ (D. M.).",
            },
            {
                value: "060104",
                label: "JAYA (D. M.).",
            },
            {
                value: "060105",
                label: "	",
            },
            {
                value: "PRESIDENTE",
                label: "DON ANTONIO GUZMÁN FERNÁNDEZ (D. M.).",
            },
            {
                value: "060200",
                label: "MUNICIPIO ARENOSO",
            },
            {
                value: "060201",
                label: "ARENOSO (D. M.).",
            },
            {
                value: "060202",
                label: "LAS COLES (D. M.).",
            },
            {
                value: "060203",
                label: "EL AGUACATE (D. M.).",
            },
            {
                value: "060300",
                label: "MUNICIPIO CASTILLO",
            },
            {
                value: "060301",
                label: "CASTILLO (D. M.).",
            },
            {
                value: "060400",
                label: "MUNICIPIO PIMENTEL",
            },
            {
                value: "060401",
                label: "PIMENTEL (D. M.).",
            },
            {
                value: "060500",
                label: "MUNICIPIO VILLA RIVA",
            },
            {
                value: "060501",
                label: "VILLA RIVA (D. M.).",
            },
            {
                value: "060502",
                label: "AGUA SANTA DEL YUNA (D. M.).",
            },
            {
                value: "060503",
                label: "CRISTO REY DE GUARAGUAO (D. M.).",
            },
            {
                value: "060504",
                label: "LAS TARANAS (D. M.).",
            },
            {
                value: "060505",
                label: "BARRAQUITO (D. M.).",
            },
            {
                value: "060600",
                label: "MUNICIPIO LAS GUÁRANAS",
            },
            {
                value: "060601",
                label: "LAS GUÁRANAS (D. M.).",
            },
            {
                value: "060700",
                label: "MUNICIPIO EUGENIO MARÍA DE HOSTOS",
            },
            {
                value: "060701",
                label: "EUGENIO MARÍA DE HOSTOS (D. M.).",
            },
            {
                value: "060702",
                label: "SABANA GRANDE (D. M.).",
            },
        ]
    },
    {
        value: "070000",
        label: "ELÍAS PIÑA",
        municipios: [
            {
                value: "070100",
                label: "MUNICIPIO COMENDADOR",
            },
            {
                value: "070101",
                label: "COMENDADOR (D. M.).",
            },
            {
                value: "070102",
                label: "SABANA LARGA (D. M.).",
            },
            {
                value: "070103",
                label: "GUAYABO (D. M.).",
            },
            {
                value: "070200",
                label: "MUNICIPIO BÁNICA",
            },
            {
                value: "070201",
                label: "BÁNICA (D. M.).",
            },
            {
                value: "070202",
                label: "SABANA CRUZ (D. M.).",
            },
            {
                value: "070203",
                label: "SABANA HIGÜERO (D. M.).",
            },
            {
                value: "070300",
                label: "MUNICIPIO EL LLANO",
            },
            {
                value: "070301",
                label: "EL LLANO (D. M.).",
            },
            {
                value: "070302",
                label: "GUANITO (D. M.).",
            },
            {
                value: "070400",
                label: "MUNICIPIO HONDO VALLE",
            },
            {
                value: "070401",
                label: "HONDO VALLE (D. M.).",
            },
            {
                value: "070402",
                label: "RANCHO DE LA GUARDIA (D. M.).",
            },
            {
                value: "070500",
                label: "MUNICIPIO PEDRO SANTANA",
            },
            {
                value: "070501",
                label: "PEDRO SANTANA (D. M.).",
            },
            {
                value: "070502",
                label: "RÍO LIMPIO (D. M.).",
            },
            {
                value: "070600",
                label: "MUNICIPIO JUAN SANTIAGO",
            },
            {
                value: "070601",
                label: "JUAN SANTIAGO (D. M.).",
            },
        ]
    },
    {
        value: "080000",
        label: "EL SEIBO",
        municipios: [
            {
                value: "080100",
                label: "MUNICIPIO EL SEIBO",
            },
            {
                value: "080101",
                label: "EL SEIBO (D. M.).",
            },
            {
                value: "080102",
                label: "PEDRO SÁNCHEZ (D. M.).",
            },
            {
                value: "080103",
                label: "SAN FRANCISCO-VICENTILLO (D. M.).",
            },
            {
                value: "080104",
                label: "SANTA LUCÍA (D. M.).",
            },
            {
                value: "080200",
                label: "MUNICIPIO MICHES",
            },
            {
                value: "080201",
                label: "MICHES (D. M.).",
            },
            {
                value: "080202",
                label: "EL CEDRO (D. M.).",
            },
            {
                value: "080203",
                label: "LA GINA (D. M.).",
            },
        ]
    },
    {
        value: "090000",
        label: "ESPAILLAT",
        municipios: [
            {
                value: "090100",
                label: "MUNICIPIO MOCA",
            },
            {
                value: "090101",
                label: "MOCA (D. M.).",
            },
            {
                value: "090102",
                label: "JOSÉ CONTRERAS (D. M.).",
            },
            {
                value: "090103",
                label: "SAN VÍCTOR (D. M.).",
            },
            {
                value: "090104",
                label: "JUAN LÓPEZ (D. M.).",
            },
            {
                value: "090105",
                label: "LAS LAGUNAS (D. M.).",
            },
            {
                value: "090106",
                label: "CANCA LA REYNA (D. M.).",
            },
            {
                value: "090107",
                label: "EL HIGÜERITO (D. M.).",
            },
            {
                value: "090108",
                label: "MONTE DE LA JAGUA (D. M.).",
            },
            {
                value: "090109",
                label: "LA ORTEGA (D. M.).",
            },
            {
                value: "090200",
                label: "MUNICIPIO CAYETANO GERMOSÉN",
            },
            {
                value: "090201",
                label: "CAYETANO GERMOSÉN (D. M.).",
            },
            {
                value: "090300",
                label: "MUNICIPIO GASPAR HERNÁNDEZ",
            },
            {
                value: "090301",
                label: "GASPAR HERNÁNDEZ (D. M.).",
            },
            {
                value: "090302",
                label: "JOBA ARRIBA (D. M.).",
            },
            {
                value: "090303",
                label: "VERAGUA (D. M.).",
            },
            {
                value: "090304",
                label: "VILLA MAGANTE (D. M.).",
            },
            {
                value: "090400",
                label: "MUNICIPIO JAMAO AL NORTE",
            },
            {
                value: "090401",
                label: "JAMAO AL NORTE (D. M.).",
            },
        ]
    },
    {
        value: "100000",
        label: "INDEPENDENCIA",
        municipios: [
            {
                value: "100100",
                label: "MUNICIPIO JIMANÍ",
            },
            {
                value: "100101",
                label: "JIMANÍ (D. M.).",
            },
            {
                value: "100102",
                label: "EL LIMÓN (D. M.).",
            },
            {
                value: "100103",
                label: "BOCA DE CACHÓN (D. M.).",
            },
            {
                value: "100200",
                label: "MUNICIPIO DUVERGÉ",
            },
            {
                value: "100201",
                label: "DUVERGÉ (D. M.).",
            },
            {
                value: "100202",
                label: "VENGAN A VER (D. M.).",
            },
            {
                value: "100300",
                label: "MUNICIPIO LA DESCUBIERTA",
            },
            {
                value: "100301",
                label: "LA DESCUBIERTA (D. M.).",
            },
            {
                value: "100400",
                label: "MUNICIPIO POSTRER RÍO",
            },
            {
                value: "100401",
                label: "POSTRER RÍO (D. M.).",
            },
            {
                value: "100402",
                label: "GUAYABAL (D. M.).",
            },
            {
                value: "100500",
                label: "MUNICIPIO CRISTÓBAL",
            },
            {
                value: "100501",
                label: "CRISTÓBAL (D. M.).",
            },
            {
                value: "100502",
                label: "BATEY 8 (D. M.).",
            },
            {
                value: "100600",
                label: "MUNICIPIO MELLA",
            },
            {
                value: "100601",
                label: "MELLA (D. M.).",
            },
            {
                value: "100602",
                label: "LA COLONIA (D. M.).",
            },
        ]
    },
    {
        value: "110000",
        label: "LA ALTAGRACIA",
        municipios: [
            {
                value: "110100",
                label: "MUNICIPIO HIGÜEY",
            },
            {
                value: "110101",
                label: "HIGÜEY (D. M.).",
            },
            {
                value: "110102",
                label: "LAS LAGUNAS DE NISIBÓN (D. M.).",
            },
            {
                value: "110103",
                label: "LA OTRA BANDA (D. M.).",
            },
            {
                value: "110104",
                label: "VERÓN PUNTA CANA (D. M.) (Incluye",
            },
            {
                value: "Bávaro",
                label: ")",
            },
            {
                value: "110200",
                label: "MUNICIPIO SAN RAFAEL DEL YUMA",
            },
            {
                value: "110201",
                label: "SAN RAFAEL DEL YUMA (D. M.).",
            },
            {
                value: "110202",
                label: "BOCA DE YUMA (D. M.).",
            },
            {
                value: "110203",
                label: "BAYAHÍBE (D. M.).",
            },
        ]
    },
    {
        value: "120000",
        label: "LA ROMANA",
        municipios: [
            {
                value: "120100",
                label: "MUNICIPIO LA ROMANA",
            },
            {
                value: "120101",
                label: "LA ROMANA (D. M.).",
            },
            {
                value: "120102",
                label: "CALETA (D. M.).",
            },
            {
                value: "120200",
                label: "MUNICIPIO GUAYMATE",
            },
            {
                value: "120201",
                label: "GUAYMATE (D. M.).",
            },
            {
                value: "120300",
                label: "MUNICIPIO VILLA HERMOSA",
            },
            {
                value: "120301",
                label: "VILLA HERMOSA (D. M.).",
            },
            {
                value: "120302",
                label: "CUMAYASA (D. M.).",
            },
        ]
    },
    {
        value: "130000",
        label: "LA VEGA",
        municipios: [
            {
                value: "130100",
                label: "MUNICIPIO LA VEGA",
            },
            {
                value: "130101",
                label: "LA VEGA (D. M.).",
            },
            {
                value: "130102",
                label: "RÍO VERDE ARRIBA (D. M.).",
            },
            {
                value: "130103",
                label: "EL RANCHITO (D. M.).",
            },
            {
                value: "130104",
                label: "TAVERAS (D. M.).",
            },
            {
                value: "130105",
                label: "DON JUAN RODRÍGUEZ (D.M.)",
            },
            {
                value: "130200",
                label: "MUNICIPIO CONSTANZA",
            },
            {
                value: "130201",
                label: "CONSTANZA (D. M.).",
            },
            {
                value: "130202",
                label: "TIREO (D. M.).",
            },
            {
                value: "130203",
                label: "LA SABINA (D. M.).",
            },
            {
                value: "130300",
                label: "MUNICIPIO JARABACOA",
            },
            {
                value: "130301",
                label: "JARABACOA (D. M.).",
            },
            {
                value: "130302",
                label: "BUENA VISTA (D. M.).",
            },
            {
                value: "130303",
                label: "MANABAO (D. M.).",
            },
            {
                value: "130400",
                label: "MUNICIPIO JIMA ABAJO",
            },
            {
                value: "130401",
                label: "JIMA ABAJO (D. M.).",
            },
            {
                value: "130402",
                label: "RINCÓN (D. M.).",
            },
        ]
    },
    {
        value: "140000",
        label: "MARÍA TRINIDAD SÁNCHEZ",
        municipios: [
            {
                value: "140100",
                label: "MUNICIPIO NAGUA",
            },
            {
                value: "140101",
                label: "NAGUA (D. M.).",
            },
            {
                value: "140102",
                label: "SAN JOSÉ DE MATANZAS (D. M.).",
            },
            {
                value: "140103",
                label: "LAS GORDAS (D. M.).",
            },
            {
                value: "140104",
                label: "ARROYO AL MEDIO (D. M.).",
            },
            {
                value: "140200",
                label: "MUNICIPIO CABRERA",
            },
            {
                value: "140201",
                label: "CABRERA (D. M.).",
            },
            {
                value: "140202",
                label: "ARROYO SALADO (D. M.).",
            },
            {
                value: "140203",
                label: "LA ENTRADA (D. M.).",
            },
            {
                value: "140300",
                label: "MUNICIPIO EL FACTOR",
            },
            {
                value: "140301",
                label: "EL FACTOR (D. M.).",
            },
            {
                value: "140302",
                label: "EL POZO (D. M.).",
            },
            {
                value: "140400",
                label: "MUNICIPIO RÍO SAN JUAN",
            },
            {
                value: "140401",
                label: "RÍO SAN JUAN (D. M.).",
            },
        ]
    },
    {
        value: "150000",
        label: "MONTE CRISTI",
        municipios: [
            {
                value: "150100",
                label: "MUNICIPIO MONTE CRISTI",
            },
            {
                value: "150101",
                label: "MONTE CRISTI (D. M.).",
            },
            {
                value: "150200",
                label: "MUNICIPIO CASTAÑUELAS",
            },
            {
                value: "150201",
                label: "CASTAÑUELAS (D. M.).",
            },
            {
                value: "150202",
                label: "PALO VERDE (D. M.).",
            },
            {
                value: "150300",
                label: "MUNICIPIO GUAYUBÍN",
            },
            {
                value: "150301",
                label: "GUAYUBÍN (D. M.).",
            },
            {
                value: "150302",
                label: "VILLA ELISA (D. M.).",
            },
            {
                value: "150303",
                label: "HATILLO PALMA (D. M.).",
            },
            {
                value: "150304",
                label: "CANA CHAPETÓN (D. M.).",
            },
            {
                value: "150400",
                label: "MUNICIPIO LAS MATAS DE SANTA CRUZ",
            },
            {
                value: "150401",
                label: "LAS MATAS DE SANTA CRUZ (D. M.).",
            },
            {
                value: "150500",
                label: "MUNICIPIO PEPILLO SALCEDO",
            },
            {
                value: "150501",
                label: "PEPILLO SALCEDO (MANZANILLO)",
            },
            {
                value: "150502",
                label: "SANTA MARÍA (D. M.)",
            },
            {
                value: "150600",
                label: "MUNICIPIO VILLA VÁSQUEZ",
            },
            {
                value: "150601",
                label: "VILLA VÁSQUEZ",
            },
        ]
    },
    {
        value: "160000",
        label: "PEDERNALES",
        municipios: [
            {
                value: "160100",
                label: "MUNICIPIO PEDERNALES",
            },
            {
                value: "160101",
                label: "PEDERNALES",
            },
            {
                value: "160102",
                label: "JOSÉ FRANCISCO PEÑA GÓMEZ (D. M.).",
            },
            {
                value: "160200",
                label: "MUNICIPIO OVIEDO",
            },
            {
                value: "160201",
                label: "OVIEDO",
            },
            {
                value: "160202",
                label: "JUANCHO (D. M.).",
            },
        ]
    },
    {
        value: "170000",
        label: "PERAVIA",
        municipios: [
            {
                value: "170100",
                label: "MUNICIPIO BANÍ",
            },
            {
                value: "170101",
                label: "BANÍ (D. M.).",
            },
            {
                value: "170102",
                label: "MATANZAS (D. M.).",
            },
            {
                value: "170103",
                label: "VILLA FUNDACIÓN (D. M.).",
            },
            {
                value: "170104",
                label: "SABANA BUEY (D. M.).",
            },
            {
                value: "170105",
                label: "PAYA (D. M.).",
            },
            {
                value: "170106",
                label: "VILLA SOMBRERO (D. M.).",
            },
            {
                value: "170107",
                label: "EL CARRETÓN (D. M.).",
            },
            {
                value: "170108",
                label: "CATALINA (D. M.).",
            },
            {
                value: "170109",
                label: "EL LIMONAL (D. M.).",
            },
            {
                value: "170110",
                label: "LAS BARÍAS (D. M.).",
            },
            {
                value: "170200",
                label: "MUNICIPIO NIZAO",
            },
            {
                value: "170201",
                label: "NIZAO",
            },
            {
                value: "170202",
                label: "PIZARRETE (D. M.).",
            },
            {
                value: "170203",
                label: "SANTANA (D. M.).",
            },
            {
                value: "170300",
                label: "MATANZAS",
            },
            {
                value: "170301",
                label: "MATANZAS",
            },
        ]
    },
    {
        value: "180000",
        label: "PUERTO PLATA",
        municipios: [
            {
                value: "180100",
                label: "MUNICIPIO PUERTO PLATA",
            },
            {
                value: "180101",
                label: "PUERTO PLATA (D. M.).",
            },
            {
                value: "180102",
                label: "YÁSICA ARRIBA (D. M.).",
            },
            {
                value: "180103",
                label: "MAIMÓN (D. M.).",
            },
            {
                value: "180200",
                label: "MUNICIPIO ALTAMIRA",
            },
            {
                value: "180201",
                label: "ALTAMIRA",
            },
            {
                value: "180202",
                label: "RÍO GRANDE (D. M.).",
            },
            {
                value: "180300",
                label: "MUNICIPIO GUANANICO",
            },
            {
                value: "180301",
                label: "GUANANICO",
            },
            {
                value: "180400",
                label: "MUNICIPIO IMBERT",
            },
            {
                value: "180401",
                label: "IMBERT",
            },
            {
                value: "180500",
                label: "MUNICIPIO LOS HIDALGOS",
            },
            {
                value: "180501",
                label: "LOS HIDALGOS",
            },
            {
                value: "180502",
                label: "NAVAS (D. M.).",
            },
            {
                value: "180600",
                label: "MUNICIPIO LUPERÓN",
            },
            {
                value: "180601",
                label: "LUPERÓN",
            },
            {
                value: "180602",
                label: "LA ISABELA (D. M.).",
            },
            {
                value: "180603",
                label: "BELLOSO (D. M.).",
            },
            {
                value: "180604",
                label: "EL ESTRECHO DE LUPERÓN OMAR BROSS (D. M.).",
            },
            {
                value: "180700",
                label: "MUNICIPIO SOSÚA",
            },
            {
                value: "180701",
                label: "SOSÚA",
            },
            {
                value: "180702",
                label: "CABARETE (D. M.).",
            },
            {
                value: "180703",
                label: "SABANETA DE YÁSICA (D. M.).",
            },
            {
                value: "180800",
                label: "MUNICIPIO VILLA ISABELA",
            },
            {
                value: "180801",
                label: "VILLA ISABELA",
            },
            {
                value: "180802",
                label: "ESTERO HONDO (D. M.).",
            },
            {
                value: "180803",
                label: "LA JAIBA (D. M.).",
            },
            {
                value: "180804",
                label: "GUALETE (D. M.).",
            },
            {
                value: "180900",
                label: "MUNICIPIO VILLA MONTELLANO",
            },
            {
                value: "180901",
                label: "VILLA MONTELLANO",
            },
        ]
    },
    {
        value: "190000",
        label: "HERMANAS MIRABAL",
        municipios: [
            {
                value: "190100",
                label: "MUNICIPIO SALCEDO",
            },
            {
                value: "190101",
                label: "SALCEDO",
            },
            {
                value: "190102",
                label: "JAMAO AFUERA (D. M.).",
            },
            {
                value: "190200",
                label: "MUNICIPIO TENARES",
            },
            {
                value: "190201",
                label: "TENARES",
            },
            {
                value: "190202",
                label: "BLANCO (D. M.).",
            },
            {
                value: "190300",
                label: "MUNICIPIO VILLA TAPIA",
            },
            {
                value: "190301",
                label: "VILLA TAPIA",
            },
        ]
    },
    {
        value: "200000",
        label: "SAMANÁ",
        municipios: [
            {
                value: "200100",
                label: "MUNICIPIO SAMANÁ",
            },
            {
                value: "200101",
                label: "SAMANÁ",
            },
            {
                value: "200102",
                label: "EL LIMÓN (D. M.).",
            },
            {
                value: "200103",
                label: "ARROYO BARRIL (D. M.).",
            },
            {
                value: "200104",
                label: "LAS GALERAS (D. M.).",
            },
            {
                value: "200200",
                label: "MUNICIPIO SÁNCHEZ",
            },
            {
                value: "200201",
                label: "SÁNCHEZ (D. M.).",
            },
            {
                value: "200300",
                label: "MUNICIPIO LAS TERRENAS",
            },
            {
                value: "200301",
                label: "LAS TERRENAS",
            },
        ]
    },
    {
        value: "210000",
        label: "SAN CRISTÓBAL",
        municipios: [
            {
                value: "210100",
                label: "MUNICIPIO SAN CRISTÓBAL",
            },
            {
                value: "210101",
                label: "SAN CRISTÓBAL (D. M.).",
            },
            {
                value: "210102",
                label: "HATO DAMAS (D. M.).",
            },
            {
                value: "210103",
                label: "HATILLO (D. M.).",
            },
            {
                value: "210200",
                label: "MUNICIPIO SABANA GRANDE DE PALENQUE",
            },
            {
                value: "210201",
                label: "SABANA GRANDE DE PALENQUE (D. M.).",
            },
            {
                value: "210300",
                label: "MUNICIPIO BAJOS DE HAINA",
            },
            {
                value: "210301",
                label: "BAJOS DE HAINA",
            },
            {
                value: "210302",
                label: "EL CARRIL (D. M.).",
            },
            {
                value: "210303",
                label: "QUITA SUEÑO (D. M.).",
            },
            {
                value: "210400",
                label: "MUNICIPIO CAMBITA GARABITOS",
            },
            {
                value: "210401",
                label: "CAMBITA GARABITOS",
            },
            {
                value: "210402",
                label: "CAMBITA EL PUEBLECITO (D. M.).",
            },
            {
                value: "210500",
                label: "MUNICIPIO VILLA ALTAGRACIA",
            },
            {
                value: "210501",
                label: "VILLA ALTAGRACIA",
            },
            {
                value: "210502",
                label: "SAN JOSÉ DEL PUERTO (D. M.).",
            },
            {
                value: "210503",
                label: "MEDINA (D. M.).",
            },
            {
                value: "210504",
                label: "LA CUCHILLA (D. M.).",
            },
            {
                value: "210600",
                label: "MUNICIPIO YAGUATE",
            },
            {
                value: "210601",
                label: "YAGUATE (D. M.).",
            },
            {
                value: "210602",
                label: "DOÑA ANA (D. M.)",
            },
            {
                value: "210700",
                label: "MUNICIPIO SAN GREGORIO DE NIGUA",
            },
            {
                value: "210701",
                label: "SAN GREGORIO DE NIGUA",
            },
            {
                value: "210800",
                label: "MUNICIPIO LOS CACAOS",
            },
            {
                value: "210801",
                label: "LOS CACAOS (D. M.).",
            },
        ]
    },
    {
        value: "220000",
        label: "SAN JUAN",
        municipios: [
            {
                value: "220100",
                label: "MUNICIPIO SAN JUAN",
            },
            {
                value: "220101",
                label: "SAN JUAN",
            },
            {
                value: "220102",
                label: "PEDRO CORTO (D. M.).",
            },
            {
                value: "220103",
                label: "SABANETA (D. M.).",
            },
            {
                value: "220104",
                label: "SABANA ALTA (D. M.).",
            },
            {
                value: "220105",
                label: "EL ROSARIO (D. M.).",
            },
            {
                value: "220106",
                label: "HATO DEL PADRE (D. M.).",
            },
            {
                value: "220107",
                label: "GUANITO (D. M.).",
            },
            {
                value: "220108",
                label: "LA JAGUA (D. M.).",
            },
            {
                value: "220109",
                label: "LAS MAGUANAS-HATO NUEVO (D. M.).",
            },
            {
                value: "220110",
                label: "LAS CHARCAS DE MARÍA NOVA (D. M.).",
            },
            {
                value: "220111",
                label: "LAS ZANJAS (D. M.)",
            },
            {
                value: "220200",
                label: "MUNICIPIO BOHECHÍO",
            },
            {
                value: "220201",
                label: "BOHECHÍO",
            },
            {
                value: "220202",
                label: "ARROYO CANO (D. M.).",
            },
            {
                value: "220203",
                label: "YAQUE (D. M.).",
            },
            {
                value: "220300",
                label: "MUNICIPIO EL CERCADO",
            },
            {
                value: "220301",
                label: "EL CERCADO",
            },
            {
                value: "220302",
                label: "DERRUMBADERO (D. M.)",
            },
            {
                value: "220303",
                label: "BATISTA (D. M.)",
            },
            {
                value: "220400",
                label: "MUNICIPIO JUAN DE HERRERA",
            },
            {
                value: "220401",
                label: "JUAN DE HERRERA",
            },
            {
                value: "220402",
                label: "JÍNOVA (D. M.).",
            },
            {
                value: "220500",
                label: "MUNICIPIO LAS MATAS DE FARFÁN",
            },
            {
                value: "220501",
                label: "LAS MATAS DE FARFÁN",
            },
            {
                value: "220502",
                label: "MATAYAYA (D. M.).",
            },
            {
                value: "220503",
                label: "CARRERA DE YEGUAS (D. M.).",
            },
            {
                value: "220600",
                label: "MUNICIPIO VALLEJUELO",
            },
            {
                value: "220601",
                label: "VALLEJUELO",
            },
            {
                value: "220602",
                label: "JORJILLO (D. M.).",
            },
        ]
    },
    {
        value: "230000",
        label: "SAN PEDRO DE MACORÍS",
        municipios: [
            {
                value: "230100",
                label: "MUNICIPIO SAN PEDRO DE MACORÍS",
            },
            {
                value: "230101",
                label: "SAN PEDRO DE MACORÍS",
            },
            {
                value: "230200",
                label: "MUNICIPIO LOS LLANOS",
            },
            {
                value: "230201",
                label: "LOS LLANOS",
            },
            {
                value: "230202",
                label: "EL PUERTO (D. M.).",
            },
            {
                value: "230203",
                label: "GAUTIER (D. M.).",
            },
            {
                value: "230300",
                label: "MUNICIPIO RAMÓN SANTANA",
            },
            {
                value: "230301",
                label: "RAMÓN SANTANA",
            },
            {
                value: "230400",
                label: "MUNICIPIO CONSUELO",
            },
            {
                value: "230401",
                label: "CONSUELO",
            },
            {
                value: "230500",
                label: "MUNICIPIO QUISQUEYA",
            },
            {
                value: "230501",
                label: "QUISQUEYA",
            },
            {
                value: "230600",
                label: "MUNICIPIO GUAYACANES",
            },
            {
                value: "230601",
                label: "GUAYACANES",
            },
        ]
    },
    {
        value: "240000",
        label: "SÁNCHEZ RAMÍREZ",
        municipios: [
            {
                value: "240100",
                label: "MUNICIPIO COTUÍ",
            },
            {
                value: "240101",
                label: "COTUÍ",
            },
            {
                value: "240102",
                label: "QUITA SUEÑO (D. M.).",
            },
            {
                value: "240103",
                label: "CABALLERO (D. M.).",
            },
            {
                value: "240104",
                label: "COMEDERO ARRIBA (D. M.).",
            },
            {
                value: "240105",
                label: "PLATANAL (D. M.).",
            },
            {
                value: "240106",
                label: "ZAMBRANA ABAJO",
            },
            {
                value: "240200",
                label: "MUNICIPIO CEVICOS",
            },
            {
                value: "240201",
                label: "CEVICOS",
            },
            {
                value: "240202",
                label: "LA CUEVA (D. M.).",
            },
            {
                value: "240300",
                label: "MUNICIPIO FANTINO",
            },
            {
                value: "240301",
                label: "FANTINO",
            },
            {
                value: "240400",
                label: "MUNICIPIO LA MATA",
            },
            {
                value: "240401",
                label: "LA MATA",
            },
            {
                value: "240402",
                label: "LA BIJA (D. M.).",
            },
            {
                value: "240403",
                label: "ANGELINA (D. M.).",
            },
            {
                value: "240404",
                label: "HERNANDO ALONZO (D. M.).",
            },
        ]
    },
    {
        value: "250000",
        label: "SANTIAGO",
        municipios: [
            {
                value: "250100",
                label: "MUNICIPIO SANTIAGO",
            },
            {
                value: "250101",
                label: "SANTIAGO",
            },
            {
                value: "250102",
                label: "PEDRO GARCÍA (D. M.).",
            },
            {
                value: "250104",
                label: "BAITOA (D. M.).",
            },
            {
                value: "250105",
                label: "LA CANELA (D. M.).",
            },
            {
                value: "250106",
                label: "SAN FRANCISCO DE JACAGUA (D. M.).",
            },
            {
                value: "250107",
                label: "HATO DEL YAQUE (D. M.).",
            },
            {
                value: "250200",
                label: "MUNICIPIO BISONÓ",
            },
            {
                value: "250201",
                label: "VILLA BISONÓ (NAVARRETE) (D. M.).",
            },
            {
                value: "250300",
                label: "MUNICIPIO JÁNICO",
            },
            {
                value: "250301",
                label: "JÁNICO",
            },
            {
                value: "250302",
                label: "JUNCALITO (D. M.).",
            },
            {
                value: "250303",
                label: "EL CAIMITO (D. M.).",
            },
            {
                value: "250400",
                label: "MUNICIPIO LICEY AL MEDIO",
            },
            {
                value: "250401",
                label: "LICEY AL MEDIO",
            },
            {
                value: "250402",
                label: "LAS PALOMAS (D. M.).",
            },
            {
                value: "250500",
                label: "MUNICIPIO SAN JOSÉ DE LAS MATAS",
            },
            {
                value: "250501",
                label: "SAN JOSÉ DE LAS MATAS",
            },
            {
                value: "250502",
                label: "EL RUBIO (D. M.).",
            },
            {
                value: "250503",
                label: "LA CUESTA (D. M.).",
            },
            {
                value: "250504",
                label: "LAS PLACETAS (D. M.).",
            },
            {
                value: "250600",
                label: "MUNICIPIO TAMBORIL",
            },
            {
                value: "250601",
                label: "TAMBORIL",
            },
            {
                value: "250602",
                label: "CANCA LA PIEDRA (D. M.).",
            },
            {
                value: "250700",
                label: "MUNICIPIO VILLA GONZÁLEZ",
            },
            {
                value: "250701",
                label: "VILLA GONZÁLEZ",
            },
            {
                value: "250702",
                label: "PALMAR ARRIBA (D. M.).",
            },
            {
                value: "250703",
                label: "EL LIMÓN (D. M.).",
            },
            {
                value: "250800",
                label: "MUNICIPIO PUÑAL",
            },
            {
                value: "250801",
                label: "PUÑAL",
            },
            {
                value: "250802",
                label: "GUAYABAL (D. M.).",
            },
            {
                value: "250803",
                label: "CANABACOA (D. M.).",
            },
            {
                value: "250900",
                label: "MUNICIPIO SABANA IGLESIA",
            },
            {
                value: "250901",
                label: "SABANA IGLESIA",
            },
            {
                value: "251000",
                label: "BAITOA",
            },
            {
                value: "251001",
                label: "BAITOA",
            },
        ]
    },
    {
        value: "260000",
        label: "SANTIAGO RODRÍGUEZ",
        municipios: [
            {
                value: "260100",
                label: "MUNICIPIO SAN IGNACIO DE SABANETA",
            },
            {
                value: "260101",
                label: "SAN IGNACIO DE SABANETA (D. M.).",
            },
            {
                value: "260200",
                label: "MUNICIPIO VILLA LOS ALMÁCIGOS",
            },
            {
                value: "260201",
                label: "VILLA LOS ALMÁCIGOS (D. M.).",
            },
            {
                value: "260300",
                label: "MUNICIPIO MONCIÓN",
            },
            {
                value: "260301",
                label: "MONCIÓN (D. M.).",
            },
        ]
    },
    {
        value: "270000",
        label: "VALVERDE",
        municipios: [
            {
                value: "270100",
                label: "MUNICIPIO MAO",
            },
            {
                value: "270101",
                label: "MAO (D. M.).",
            },
            {
                value: "270102",
                label: "AMINA (D. M.).",
            },
            {
                value: "270103",
                label: "JAIBÓN (PUEBLO NUEVO) (D. M.).",
            },
            {
                value: "270104",
                label: "GUATAPANAL (D. M.).",
            },
            {
                value: "270200",
                label: "MUNICIPIO ESPERANZA",
            },
            {
                value: "270201",
                label: "ESPERANZA",
            },
            {
                value: "270202",
                label: "MAIZAL (D. M.).",
            },
            {
                value: "270203",
                label: "JICOMÉ (D. M.).",
            },
            {
                value: "270204",
                label: "BOCA DE MAO (D. M.).",
            },
            {
                value: "270205",
                label: "PARADERO (D. M.).",
            },
            {
                value: "270300",
                label: "MUNICIPIO LAGUNA SALADA",
            },
            {
                value: "270301",
                label: "LAGUNA SALADA (D. M.).",
            },
            {
                value: "270302",
                label: "JAIBÓN (D. M.).",
            },
            {
                value: "270303",
                label: "LA CAYA (D. M.).",
            },
            {
                value: "270304",
                label: "CRUCE DE GUAYACANES (D. M.).",
            },
        ]
    },
    {
        value: "280000",
        label: "MONSEÑOR NOUEL",
        municipios: [
            {
                value: "280100",
                label: "MUNICIPIO BONAO",
            },
            {
                value: "280101",
                label: "BONAO (D. M.).",
            },
            {
                value: "280102",
                label: "SABANA DEL PUERTO (D. M.).",
            },
            {
                value: "280103",
                label: "JUMA BEJUCAL (D. M.).",
            },
            {
                value: "280104",
                label: "ARROYO TORO - MASIPEDRO (D. M.).",
            },
            {
                value: "280105",
                label: "JAYACO (D. M.).",
            },
            {
                value: "280106",
                label: "LA SALVIA - LOS QUEMADOS (D. M.).",
            },
            {
                value: "280200",
                label: "MUNICIPIO MAIMÓN",
            },
            {
                value: "280201",
                label: "MAIMÓN (D. M.).",
            },
            {
                value: "280300",
                label: "MUNICIPIO PIEDRA BLANCA",
            },
            {
                value: "280301",
                label: "PIEDRA BLANCA (D. M.).",
            },
            {
                value: "280302",
                label: "VILLA DE SONADOR (D. M.).",
            },
            {
                value: "280303",
                label: "JUAN ADRIÁN (D. M.).",
            },
        ]
    },
    {
        value: "290000",
        label: "MONTE PLATA",
        municipios: [
            {
                value: "290100",
                label: "MUNICIPIO MONTE PLATA",
            },
            {
                value: "290101",
                label: "MONTE PLATA (D. M.).",
            },
            {
                value: "290102",
                label: "DON JUAN (D. M.).",
            },
            {
                value: "290103",
                label: "CHIRINO (D. M.).",
            },
            {
                value: "290104",
                label: "BOYÁ (D. M.).",
            },
            {
                value: "290200",
                label: "MUNICIPIO BAYAGUANA",
            },
            {
                value: "290201",
                label: "BAYAGUANA (D. M.).",
            },
            {
                value: "290300",
                label: "MUNICIPIO SABANA GRANDE DE BOYÁ",
            },
            {
                value: "290301",
                label: "SABANA GRANDE DE BOYÁ (D. M.).",
            },
            {
                value: "290302",
                label: "GONZALO (D. M.).",
            },
            {
                value: "290303",
                label: "MAJAGUAL (D. M.).",
            },
            {
                value: "290400",
                label: "MUNICIPIO YAMASÁ",
            },
            {
                value: "290402",
                label: "LOS BOTADOS (D. M.).",
            },
            {
                value: "290403",
                label: "MAMÁ TINGÓ (D. M.).",
            },
            {
                value: "290500",
                label: "MUNICIPIO PERALVILLO",
            },
            {
                value: "290501",
                label: "PERALVILLO (D. M.).",
            },
        ]
    },
    {
        value: "300000",
        label: "HATO MAYOR",
        municipios: [
            {
                value: "300100",
                label: "MUNICIPIO HATO MAYOR",
            },
            {
                value: "300101",
                label: "HATO MAYOR (D. M.).",
            },
            {
                value: "300102",
                label: "YERBA BUENA (D. M.).",
            },
            {
                value: "300103",
                label: "MATA PALACIO (D. M.).",
            },
            {
                value: "300104",
                label: "GUAYABO DULCE (D. M.).",
            },
            {
                value: "300200",
                label: "MUNICIPIO SABANA DE LA MAR",
            },
            {
                value: "300201",
                label: "SABANA DE LA MAR (D. M.).",
            },
            {
                value: "300202",
                label: "ELUPINA CORDERO DE LAS CAÑITAS (D. M.).",
            },
            {
                value: "300300",
                label: "MUNICIPIO EL VALLE",
            },
            {
                value: "300301",
                label: "EL VALLE (D. M.).",
            },
        ]
    },
    {
        value: "310000",
        label: "SAN JOSÉ DE OCOA",
        municipios: [
            {
                value: "310100",
                label: "MUNICIPIO SAN JOSÉ DE OCOA",
            },
            {
                value: "310101",
                label: "SAN JOSÉ DE OCOA (D. M.).",
            },
            {
                value: "310102",
                label: "LA CIÉNAGA (D. M.).",
            },
            {
                value: "310103",
                label: "NIZAO - LAS AUYAMAS (D. M.).",
            },
            {
                value: "310104",
                label: "EL PINAR (D. M.).",
            },
            {
                value: "310105",
                label: "EL NARANJAL (D. M.).",
            },
            {
                value: "310200",
                label: "MUNICIPIO SABANA LARGA",
            },
            {
                value: "310201",
                label: "SABANA LARGA (D. M.).",
            },
            {
                value: "310300",
                label: "MUNICIPIO RANCHO ARRIBA",
            },
            {
                value: "310301",
                label: "RANCHO ARRIBA (D. M.).",
            },
        ]
    },
    {
        value: "320000",
        label: "SANTO DOMINGO",
        municipios: [
            {
                value: "320100",
                label: "MUNICIPIO SANTO DOMINGO ESTE",
            },
            {
                value: "320101",
                label: "SANTO DOMINGO ESTE (D. M.).",
            },
            {
                value: "320102",
                label: "SAN LUIS (D. M.).",
            },
            {
                value: "320200",
                label: "MUNICIPIO SANTO DOMINGO OESTE",
            },
            {
                value: "320201",
                label: "SANTO DOMINGO OESTE (D. M.).",
            },
            {
                value: "320300",
                label: "MUNICIPIO SANTO DOMINGO NORTE",
            },
            {
                value: "320301",
                label: "SANTO DOMINGO NORTE (D. M.).",
            },
            {
                value: "320302",
                label: "LA VICTORIA (D. M.).",
            },
            {
                value: "320400",
                label: "MUNICIPIO BOCA CHICA",
            },
            {
                value: "320401",
                label: "BOCA CHICA (D. M.).",
            },
            {
                value: "320402",
                label: "LA CALETA (D. M.).",
            },
            {
                value: "320500",
                label: "MUNICIPIO SAN ANTONIO DE GUERRA",
            },
            {
                value: "320501",
                label: "SAN ANTONIO DE GUERRA (D. M.).",
            },
            {
                value: "320502",
                label: "HATO VIEJO (D. M.).",
            },
            {
                value: "320600",
                label: "MUNICIPIO LOS ALCARRIZOS",
            },
            {
                value: "320601",
                label: "LOS ALCARRIZOS (D. M.).",
            },
            {
                value: "320602",
                label: "PALMAREJO-VILLA LINDA (D. M.).",
            },
            {
                value: "320603",
                label: "PANTOJA (D. M.).",
            },
            {
                value: "320700",
                label: "MUNICIPIO PEDRO BRAND",
            },
            {
                value: "320701",
                label: "PEDRO BRAND (D. M.).",
            },
            {
                value: "320702",
                label: "LA GUÁYIGA (D. M.).",
            },
            {
                value: "320703",
                label: "LA CUABA (D. M.).",
            }
        ]
    }
]
